import { parsePhoneNumber } from "libphonenumber-js";
import "./style.scss";

const AuthInput = ({
  type,
  value,
  queryValue,
  placeholder,
  changeValue,
  autoComplete,
  name,
  EyeIcon,
  HiddenIcon,
  changePasswordVisibility,
  disability,
  styled,
}) => {
  const numberStyles = {
    ...(styled ? { margin: 0 } : {}),

    ...(styled > 1 && styled < 4
      ? { width: "240px" }
      : styled >= 4
        ? { width: "220px" }
        : {}),
  };

  let number = +queryValue;
  let queryPhone = number ? parsePhoneNumber(`+${number}`).nationalNumber : "";

  return (
    <div className={`auth-input-container ${type}`}>
      <input
        style={numberStyles}
        name={name}
        disabled={disability}
        id={name}
        className="input"
        type={type}
        autoComplete={autoComplete}
        value={disability === false ? value : number ? queryPhone : queryValue}
        placeholder={placeholder}
        onChange={(e) => {
          changeValue(e.target.value);
        }}
      />

      <div
        id="eye"
        onClick={() => {
          changePasswordVisibility("password");
        }}
      >
        {HiddenIcon ? <HiddenIcon /> : null}
      </div>
      <div
        id="hidden"
        onClick={() => {
          changePasswordVisibility("text");
        }}
      >
        {EyeIcon ? <EyeIcon /> : null}
      </div>
    </div>
  );
};

export default AuthInput;
